export const createExpense = /* GraphQL */ `
  mutation CreateExpense($input: CreateExpenseInput!, $condition: ModelExpenseConditionInput) {
    createExpense(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createExpenseItem = /* GraphQL */ `
  mutation CreateExpenseItem($input: CreateExpenseItemInput!, $condition: ModelExpenseItemConditionInput) {
    createExpenseItem(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteExpense = /* GraphQL */ `
  mutation DeleteExpense($input: DeleteExpenseInput!, $condition: ModelExpenseConditionInput) {
    deleteExpense(input: $input, condition: $condition) {
      id
    }
  }
`;
export const deleteExpenseItem = /* GraphQL */ `
  mutation DeleteExpenseItem($input: DeleteExpenseItemInput!, $condition: ModelExpenseItemConditionInput) {
    deleteExpenseItem(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateExpense = /* GraphQL */ `
  mutation UpdateExpense($input: UpdateExpenseInput!, $condition: ModelExpenseConditionInput) {
    updateExpense(input: $input, condition: $condition) {
      id
    }
  }
`;
export const updateExpenseItem = /* GraphQL */ `
  mutation UpdateExpenseItem($input: UpdateExpenseItemInput!, $condition: ModelExpenseItemConditionInput) {
    updateExpenseItem(input: $input, condition: $condition) {
      id
    }
  }
`;
export const createAudit = /* GraphQL */ `
  mutation CreateAudit($input: CreateAuditInput!) {
    createAudit(input: $input) {
      id
    }
  }
`;
// CP-836 — AI Client Qualification CRUD (hand-written so the feature compiles before codegen).
export const createAiClientQualification = /* GraphQL */ `
  mutation CreateAiClientQualification($input: CreateAiClientQualificationInput!) {
    createAiClientQualification(input: $input) {
      id
    }
  }
`;
export const updateAiClientQualification = /* GraphQL */ `
  mutation UpdateAiClientQualification($input: UpdateAiClientQualificationInput!) {
    updateAiClientQualification(input: $input) {
      id
    }
  }
`;
export const deleteAiClientQualification = /* GraphQL */ `
  mutation DeleteAiClientQualification($input: DeleteAiClientQualificationInput!) {
    deleteAiClientQualification(input: $input) {
      id
    }
  }
`;
// CP-836 managed prompt store (guardrail 5). Save = create a new active version row + deactivate
// the prior one (append-only, so history is preserved for reportability).
export const createAiPrompt = /* GraphQL */ `
  mutation CreateAiPrompt($input: CreateAiPromptInput!) {
    createAiPrompt(input: $input) {
      id
      promptKey
      version
      active
    }
  }
`;
export const updateAiPrompt = /* GraphQL */ `
  mutation UpdateAiPrompt($input: UpdateAiPromptInput!) {
    updateAiPrompt(input: $input) {
      id
      promptKey
      version
      active
    }
  }
`;
export const createAiClientQualificationDocument = /* GraphQL */ `
  mutation CreateAiClientQualificationDocument($input: CreateAiClientQualificationDocumentInput!) {
    createAiClientQualificationDocument(input: $input) {
      id
    }
  }
`;
export const deleteAiClientQualificationDocument = /* GraphQL */ `
  mutation DeleteAiClientQualificationDocument($input: DeleteAiClientQualificationDocumentInput!) {
    deleteAiClientQualificationDocument(input: $input) {
      id
    }
  }
`;
// DQF mutations without relational selections.
//
// CP-836 added a second auth rule to DriverQualification (`{ allow: private, provider: iam }`), which
// makes it a multi-auth model. The transformer then generates subscription-field protection into every
// DriverQualification connection resolver: when the parent result carries `__operation: "Mutation"`,
// the field is stashed as denied. For @hasMany that returns an empty `items: []`; for @hasOne /
// @belongsTo the generated template short-circuits with `#return($util.toJson(null))`, which returns
// the *string* "null" and makes AppSync error on every non-nullable subfield ("Cannot return null for
// non-nullable type: 'ID' within parent 'State'"). aws-amplify rejects any response carrying errors,
// so the whole mutation appears to fail even though the write succeeded.
//
// Relational fields therefore cannot be hydrated on a mutation response at all — re-query if you need
// them. These documents select scalars only. Hand-written so `amplify codegen statements` can't
// reintroduce the nested selections.
export const createDriverQualification = /* GraphQL */ `
  mutation CreateDriverQualification(
    $input: CreateDriverQualificationInput!
    $condition: ModelDriverQualificationConditionInput
  ) {
    createDriverQualification(input: $input, condition: $condition) {
      id
      tier
      customerId
      name
      driverId
      driverName
      status
      jobId
      jobStartDate
      createEmail
      updateUser
      dqSpecialistUser
      dqSpecialistEmail
      createUserFullName
      dqOwnerFullName
      dqClientApproverUser
      dqClientApproverUserFullName
      dqDocumentName
      createdAt
      tierDescription
      branch
      driverSkillSummary
      accountMasterCode
      checkListLevel
      fileType
      clientVisible
      updatedAt
      driverQualificationLocationStateId
      driverQualificationLocationCityId
    }
  }
`;
export const updateDriverQualification = /* GraphQL */ `
  mutation UpdateDriverQualification(
    $input: UpdateDriverQualificationInput!
    $condition: ModelDriverQualificationConditionInput
  ) {
    updateDriverQualification(input: $input, condition: $condition) {
      id
      tier
      customerId
      name
      driverId
      driverName
      status
      jobId
      jobStartDate
      createEmail
      updateUser
      dqSpecialistUser
      dqSpecialistEmail
      createUserFullName
      dqOwnerFullName
      dqClientApproverUser
      dqClientApproverUserFullName
      dqDocumentName
      createdAt
      tierDescription
      branch
      driverSkillSummary
      accountMasterCode
      checkListLevel
      fileType
      clientVisible
      updatedAt
      driverQualificationLocationStateId
      driverQualificationLocationCityId
    }
  }
`;
export const createQuestions = /* GraphQL */ `
  mutation CreateQuestions($input: CreateQuestionsInput!, $condition: ModelQuestionsConditionInput) {
    createQuestions(input: $input, condition: $condition) {
      id
      user
      text
      createUserFullName
      type
      status
      createdAt
      updatedAt
      driverQualificationQuestionsId
    }
  }
`;
export const updateQuestions = /* GraphQL */ `
  mutation UpdateQuestions($input: UpdateQuestionsInput!, $condition: ModelQuestionsConditionInput) {
    updateQuestions(input: $input, condition: $condition) {
      id
      user
      text
      createUserFullName
      type
      status
      createdAt
      updatedAt
      driverQualificationQuestionsId
    }
  }
`;
export const createDriverQualificationServiceTeamNotes = /* GraphQL */ `
  mutation CreateDriverQualificationServiceTeamNotes(
    $input: CreateDriverQualificationServiceTeamNotesInput!
    $condition: ModelDriverQualificationServiceTeamNotesConditionInput
  ) {
    createDriverQualificationServiceTeamNotes(input: $input, condition: $condition) {
      id
      user
      text
      createUserFullName
      createdAt
      updatedAt
      driverQualificationDriverQualificationServiceTeamNotesId
    }
  }
`;
// CP-836 — custom @function mutation (codegen doesn't emit @function ops cleanly; mirrors report in
// customQueries.js). Kicks off an async DQF AI audit and returns the PROCESSING DqfAudit record.
export const runDqfAudit = /* GraphQL */ `
  mutation RunDqfAudit($dqfId: ID!, $effort: String, $model: String, $reviewDate: AWSDate) {
    runDqfAudit(dqfId: $dqfId, effort: $effort, model: $model, reviewDate: $reviewDate) {
      id
      dqfId
      customerId
      status
      resultNote
      qualListAvailable
      qualListId
      promptVersion
      model
      effort
      reviewDate
      exceptions
      exceptionCount
      inputTokens
      outputTokens
      processingTimeMs
      requestId
      errorMessage
      createdBy
      createdAt
    }
  }
`;
